import { match } from "ts-pattern";

import Icon from "@/components/Icon/Icon";
import {
  RULE_MATCHING,
  type RuleMatching,
} from "@/features/app-user/types/ruleMatch";
import { defaultNS, useTranslation } from "@/lib/i18n";

interface Props {
  rule: RuleMatching | undefined;
}

const AssignmentRuleCell = ({ rule }: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.dataTable.cells.AssignmentRuleCell",
  });

  return match(rule)
    .with(RULE_MATCHING.MATCHED, () => (
      <Icon
        iconName="UserRoundCheckIcon"
        text={t("following")}
        variant="small"
        colorVariant="primary"
        textColor="text-primary"
      />
    ))
    .with(RULE_MATCHING.VIOLATED, () => (
      <Icon
        iconName="UserRoundXIcon"
        text={t("violated")}
        variant="small"
        colorVariant="error"
        textColor="text-error-on-neutral-fill"
      />
    ))
    .with(RULE_MATCHING.NO_WORKER, () => (
      <Icon
        iconName="SearchXIcon"
        text={t("unknown")}
        variant="small"
        colorVariant="error"
        textColor="text-error-on-neutral-fill"
      />
    ))
    .with(RULE_MATCHING.NO_USER, () => (
      <Icon
        iconName="UserRoundSearchIcon"
        text={t("noUser")}
        variant="small"
        colorVariant="error"
        textColor="text-error-on-neutral-fill"
      />
    ))
    .with(RULE_MATCHING.VIOLATED_ROLE, () => (
      <Icon
        iconName="IncorrectRoleIcon"
        text={t("incorrectRole")}
        variant="small"
        colorVariant="error"
        textColor="text-error-on-neutral-fill"
      />
    ))
    .otherwise(() => (
      <Icon
        iconName="SearchXIcon"
        text={t("unknown")}
        variant="small"
        colorVariant="error"
        textColor="text-error-on-neutral-fill"
      />
    ));
};

export default AssignmentRuleCell;
